import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FiArrowLeft, FiCheck, FiPlus, FiUserCheck, FiX } from 'react-icons/fi';
import SideBar from '../../../components/sidebar/Sidebar';
import { useUpdateStatus } from '../Modal/ClientsAssign/hook';

const OperationalUserDetails = () => {
  const { id } = useParams();
  const { alluserList, defaultData, userDetails, doSubmitUrl } = useUpdateStatus(id);
  const [selectedClient, setSelectedClient] = useState('');
  const [assignedClients, setAssignedClients] = useState([]);

  useEffect(() => {
    setAssignedClients(defaultData || []);
    setSelectedClient('');
  }, [defaultData, id]);

  const availableClients = alluserList.filter((client) =>
    client.role === 'client' && client.active === true
    && !assignedClients.some((assigned) => assigned._id === client._id)
  );

  const handleAdd = () => {
    const client = availableClients.find((item) => item._id === selectedClient);
    if (!client) return;
    setAssignedClients((current) => [...current, client]);
    setSelectedClient('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!userDetails) return;
    doSubmitUrl({ clients: assignedClients.map((client) => client._id), id });
  };

  return (
    <SideBar>
      <section className="create-page user-create-page assignment-page" aria-labelledby="assignment-title">
        <Link className="user-back-link" to="/operations"><FiArrowLeft aria-hidden="true" />Operations</Link>
        <header className="create-page-header">
          <span className="create-page-icon" aria-hidden="true"><FiUserCheck /></span>
          <div className="assignment-heading">
            <h1 id="assignment-title">Assign clients</h1>
            <p>{userDetails ? userDetails.username : 'Loading operational...'}</p>
          </div>
        </header>

        <form className="create-form" onSubmit={handleSubmit}>
          <div className="create-field">
            <label htmlFor="assignment-client">Client</label>
            <div className="assignment-picker">
              <select
                id="assignment-client"
                className="form-select form-control"
                value={selectedClient}
                onChange={(event) => setSelectedClient(event.target.value)}
                disabled={!userDetails || availableClients.length === 0}
              >
                <option value="">{availableClients.length === 0 && userDetails ? 'No available clients' : 'Select a client'}</option>
                {availableClients.map((client) => <option key={client._id} value={client._id}>{client.username}</option>)}
              </select>
              <button type="button" className="assignment-add" onClick={handleAdd} disabled={!selectedClient}>
                <FiPlus aria-hidden="true" />Add client
              </button>
            </div>
          </div>

          <section className="assignment-list-section" aria-labelledby="assigned-clients-title">
            <div className="assignment-list-header">
              <h2 id="assigned-clients-title">Assigned clients</h2>
              <span className="assignment-count" aria-label={`${assignedClients.length} assigned clients`}>{assignedClients.length}</span>
            </div>
            {assignedClients.length > 0 ? (
              <ul className="assignment-list">
                {assignedClients.map((client) => (
                  <li key={client._id}>
                    <span className="assignment-client-avatar" aria-hidden="true">{client.username?.charAt(0).toUpperCase()}</span>
                    <div className="assignment-client-details">
                      <span className="assignment-client-name">{client.username}</span>
                      {client.mobile && <span className="assignment-client-mobile">{client.mobile}</span>}
                    </div>
                    <button
                      type="button"
                      className="shortlinks-copy assignment-remove"
                      title={`Remove ${client.username}`}
                      aria-label={`Remove ${client.username}`}
                      onClick={() => setAssignedClients((current) => current.filter((item) => item._id !== client._id))}
                    ><FiX size={18} /></button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="assignment-empty">{userDetails ? 'No clients assigned.' : 'Loading assigned clients...'}</div>
            )}
          </section>

          <div className="create-form-actions user-form-actions">
            <Link className="user-cancel-link" to="/operations">Cancel</Link>
            <button type="submit" className="create-submit" disabled={!userDetails}><FiCheck aria-hidden="true" />Save assignments</button>
          </div>
        </form>
      </section>
    </SideBar>
  );
};

export default OperationalUserDetails;